import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../Config/ApiConfig";
import { toast } from "react-toastify";

export const fetchKbArticles = createAsyncThunk("kb/fetchArticles", async (params) => {
  try {
    const res = await Api.get("kb", { params });
    if (res.data?.status_code === 200) {
      return res.data;
    }
    return { data: [], totalItems: 0 };
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to load KB articles");
    throw err;
  }
});

export const createKbArticle = createAsyncThunk("kb/createArticle", async (payload) => {
  try {
    const res = await Api.post("kb", payload);
    if (res.data?.status_code === 201) {
      toast.success("Article created successfully");
      return res.data?.data;
    }
    throw new Error(res.data?.message || "Failed to create article");
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to create article");
    throw err;
  }
});

export const updateKbArticle = createAsyncThunk("kb/updateArticle", async ({ id, data }) => {
  try {
    const res = await Api.put(`kb/${id}`, data);
    if (res.data?.status_code === 200) {
      toast.success("Article updated successfully");
      return res.data?.data;
    }
    throw new Error(res.data?.message || "Failed to update article");
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to update article");
    throw err;
  }
});

export const updateKbArticleStatus = createAsyncThunk("kb/updateStatus", async ({ id, status }) => {
  try {
    const res = await Api.patch(`kb/${id}/status`, { status });
    if (res.data?.status_code === 200) {
      toast.success(`Article ${status.toLowerCase()} successfully`);
      return res.data?.data;
    }
    throw new Error(res.data?.message || "Failed to update status");
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to update status");
    throw err;
  }
});

export const deleteKbArticle = createAsyncThunk("kb/deleteArticle", async (id) => {
  try {
    const res = await Api.delete(`kb/${id}`);
    if (res.data?.status_code === 200) {
      toast.success("Article deleted successfully");
      return id;
    }
    throw new Error(res.data?.message || "Failed to delete article");
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to delete article");
    throw err;
  }
});

export const searchKbArticles = createAsyncThunk("kb/search", async ({ q, domain }) => {
  try {
    const res = await Api.get("kb/search", { params: { q, domain } });
    if (res.data?.status_code === 200) {
      return res.data?.data;
    }
    return [];
  } catch (err) {
    toast.error(err?.response?.data?.message || "Search failed");
    throw err;
  }
});
